import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  state: {
    map: null,
    mapHandle: null,
    threeTiles: null,
    imagePath: {},
    markerList: [],
    bind_code: '',
    drone_sn: '',
    duibiInfo: null,
    cunluo: ''
  },
  modules,
  getters,
  mutations: {
    set_cunluo(state, val) {
      state.cunluo = val
    },
    set_map(state, val) {
      state.map = val
    },
    set_hand_map(state, val) {
      state.mapHandle = val
    },
    set_threeTiles(state, val) {
      state.threeTiles = val
    },
    set_path(state, val) {
      state.imagePath = val
    },
    set_marker(state, val) {
      state.markerList = val
    },
    set_bind_code(state, val) {
      state.bind_code = val
    },
    set_drone_sn(state, val) {
      state.drone_sn = val
    },
    set_duibiInfo(state, val) {
      state.duibiInfo = val
    }
  }
})

export default store
